import dynamic from 'next/dynamic'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Button, { ButtonProps } from 'app/components/base/Button'
import useModal from 'app/hooks/useModal'

import useVerifyAuth from '../hooks/useVerifyAuth'

const MakeOfferDialog = dynamic(() => import('./dialogs/MakeOfferDialog'), {
  ssr: false
})

interface MakeOfferButtonProps {
  textButton?: string
  disabled?: boolean
  buttonProps?: ButtonProps
  listingId: string
  listingCurrency: string
  availableQuantity?: number
}

const MakeOfferButton: RFC<MakeOfferButtonProps> = ({
  disabled,
  buttonProps,
  listingId,
  textButton,
  listingCurrency,
  availableQuantity
}) => {
  const { open, hideModal, showModal } = useModal()

  const { sx, ...props } = buttonProps || {}

  const checkAuth = useVerifyAuth()

  return (
    <>
      <Button
        variant="outlined"
        onClick={() => {
          checkAuth(showModal)
        }}
        sx={{
          flex: 1,
          maxWidth: 165,
          ...Platform.select({ native: { borderRadius: 8 } }),
          ...sx
        }}
        disabled={disabled}
        {...props}
      >
        {textButton || <FormattedMessage defaultMessage="Make an Offer" />}
      </Button>

      {open && (
        <MakeOfferDialog
          open={open}
          onClose={hideModal}
          listingId={listingId}
          listingCurrency={listingCurrency}
          availableQuantity={availableQuantity}
        />
      )}
    </>
  )
}

export default MakeOfferButton
